import { Auth as IDaveAuth, Permissions } from '@revolut-internal/idave-web-auth'

import { isProd } from 'common/env'
import { BASE_API_URL } from 'common/http'

export const RTM_SERVICE_NAME = 'rtm'
const IDAVE_ADMIN_API_URL = '/idave-api'
const RTM_API_URL = '/api'

export type AppPermissionsMap = {
  [RTM_SERVICE_NAME]: (
    | 'admin.create.one_time_job'
    | 'agents.view.list'
    | 'areas.view.list'
    | 'alerting.create.incidents.timelines.search'
    | 'alerting.create.policies'
    | 'alerting.delete.policies'
    | 'alerting.create.slack.user_groups.refresh'
    | 'alerting.update.incidents.acknowledge'
    | 'alerting.update.incidents.close'
    | 'alerting.update.incidents.action.complete'
    | 'alerting.update.incidents.action.skip'
    | 'alerting.view.metrics.list'
    | 'alerting.view.policies.list'
    | 'alerting.view.slack.user_groups.list'
    | 'alerting.view.actions.list'
    | 'analytics.view.agent_tickets.list'
    | 'analytics.view.agents.attendance.aggregated.list'
    | 'analytics.view.agents.attendance.details.list'
    | 'analytics.view.agents.metrics.breakdown.list'
    | 'analytics.view.agents.metrics.leaderboard.list'
    | 'analytics.view.agents.metrics.overview.list'
    | 'analytics.view.outcomes.volume.list'
    | 'analytics.view.queues.details.list'
    | 'analytics.view.team_leads.metrics.breakdown.list'
    | 'analytics.view.team_leads.metrics.leaderboard.list'
    | 'analytics.view.team_leads.metrics.overview.list'
    | 'analytics.view.tickets.list'
    | 'analytics.view.tickets.queue_stats_filter.list'
    | 'analytics.view.tickets.volume.list'
    | 'analytics.create.agents.attendance.short'
    | 'channels.view.list'
    | 'departments.view.list'
    | 'idave.create.oauth2.logout'
    | 'idave.view.oauth2.code.list'
    | 'line_managers.view.list'
    | 'oauth2.view.backup.details'
    | 'permissions.view.acl.list'
    | 'queues.view.list'
    | 'slack.create.interaction'
    | 'specialisations.view.list'
    | 'teams.view.list'
    | 'users.view.list'
  )[]
}
export type RtmPermission = AppPermissionsMap[typeof RTM_SERVICE_NAME][number]

export const Auth = new IDaveAuth({
  iDaveClientId: isProd()
    ? '350d2fb5-391d-4518-84f6-75514d294732'
    : '78911050-48b8-49fe-8512-2373e543f033',
  iDaveHost: isProd() ? 'https://id.revolut.com' : 'https://id.revolut.codes',
  apiUrl: BASE_API_URL,
})

export const permissions = new Permissions<AppPermissionsMap>({
  iDaveApiProxyUrl: IDAVE_ADMIN_API_URL,
  servicesApiMap: {
    [RTM_SERVICE_NAME]: RTM_API_URL,
  },
})
